import {gql} from "@apollo/client";

/**
 * Phase 8 (RETRY-04) — GraphQL-Operations fuer die Mollie-Retry-Warteschlange.
 *
 * Query + Mutation werden vom Admin-Resolver bereitgestellt (siehe Plan 08-05):
 *   - `getMollieRetryQueueEntries`  — liefert alle Attempts, die manuelle
 *     Aufmerksamkeit brauchen (`requiresManualRetry=true` + `isCurrentAttempt=true`).
 *   - `retryMolliePaymentManually`  — triggert einen manuellen Retry, schuetzt
 *     mit 6 HIGH-3 Business-Guards vor €10-Mollie-Gebuehren bei ungueltigen
 *     Retries (already_paid, booking_cancelled, stale_attempt, already_succeeded,
 *     sepa_disabled, ownership).
 */

export const GET_MOLLIE_RETRY_QUEUE_ENTRIES = gql`
    query GetMollieRetryQueueEntries {
        getMollieRetryQueueEntries {
            attemptId
            scheduledPaymentId
            bookingId
            bookerName
            bookerEmail
            amount
            currency
            chargebackReason
            chargebackedAt
            chargebackRetryCount
            sepaDisabled
            isNonRetriable
        }
    }
`;

export const RETRY_MOLLIE_PAYMENT_MANUALLY = gql`
    mutation RetryMolliePaymentManually($scheduledPaymentId: ID!) {
        retryMolliePaymentManually(scheduledPaymentId: $scheduledPaymentId)
    }
`;
